import { useEffect, useState } from 'react';

import { SignatureCountry } from '../types';
import {
  checkCiParaguay,
  checkDniArgentina,
  checkDniNieSpain,
  checkNuipColombia,
  checkPersonalIdOtherCountries,
  checkRucPeru,
  checkRutChile,
  formatCiParaguay,
  formatDniArgentina,
  formatDniNieSpain,
  formatNuipColombia,
  formatRucPeru,
  formatRutChile,
} from '../utils/rutUtils';

export function useTaxIdUsers(initialTaxId: string) {
  const [value, setValue] = useState(initialTaxId);
  const [valid, setValid] = useState(true);
  const [country, setCountry] = useState('');

  const checkTaxId = (taxId: string) => {
    switch (country) {
      case 'CL':
        return checkRutChile(taxId);
      case 'PE':
        return checkRucPeru(taxId);
      case 'CO':
        return checkNuipColombia(taxId);
      case 'AR':
        return checkDniArgentina(taxId);
      case 'PY':
        return checkCiParaguay(taxId);
      case 'ES':
        return checkDniNieSpain(taxId);
      default:
        return checkPersonalIdOtherCountries(country, taxId);
    }
  };

  const formatTaxId = (taxId: string) => {
    switch (country) {
      case 'CL':
        return formatRutChile(taxId);
      case 'PE':
        return formatRucPeru(taxId);
      case 'CO':
        return formatNuipColombia(taxId);
      case 'AR':
        return formatDniArgentina(taxId);
      case 'PY':
        return formatCiParaguay(taxId);
      case 'ES':
        return formatDniNieSpain(taxId);
      default:
        return taxId;
    }
  };

  useEffect(() => {
    if (value !== '') {
      setTaxId(value);
    }
  }, [country]);

  const setTaxId = (taxId: string) => {
    const formattedTaxId = formatTaxId(taxId);
    setValue(formattedTaxId);
    setValid(checkTaxId(formattedTaxId));
  };

  return {
    taxId: { value, valid, country: country as SignatureCountry },
    setTaxId,
    setCountry,
  };
}
